<div id="tickets" class="bg-[var(--primary-color)]">
    <div class="container">
        <div class="flex justify-between">
            <section class="mb-5 w-full mt-10">
                <h1 class="text-white text-[17px] font-black mb-5 pl-10">{{ 'homepage.season-passes'  | translate}}</h1>
                <app-season-pass-list [seasonPasses]="seasonPasses.seasonPasses"></app-season-pass-list>
            </section>
        </div>
    </div>
</div>